<template>
	<VerticalLayout>
		<DividerAutoDirection>{{ $t('base-stations-edit.fields.subNetworksDivider') }}</DividerAutoDirection>
		<Row>
			<Col span="24" offset="0" :sm="{ span, offset }">
				<CheckboxesComponent v-model:value="selectedSubNetworks" class="width-100" bordered>
					<Checkbox v-for="subNetwork in subNetworkOptions" :key="subNetwork.value" :value="subNetwork.value">
						{{ subNetwork.label }}
					</Checkbox>
				</CheckboxesComponent>
			</Col>
		</Row>
		<TypographyText type="secondary">{{ description }}</TypographyText>
	</VerticalLayout>
</template>

<script>
import { Row, Col, Checkbox, TypographyText } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';
import CheckboxesComponent from '@/components/common/CheckboxesComponent.vue';

import { useSubformFieldProxy } from '@/components/addBaseStation/useSubformFieldProxies';
import { useSubnetworkOptions } from '@/components/common/useSubnetworkOptions';

export default {
	components: {
		Row, Col, Checkbox, TypographyText,
		CheckboxesComponent,
		DividerAutoDirection,
		VerticalLayout,
	},
	emits: ['updateFormState'],
	props: {
		formState: { type: Object, required: true },
		formSettings: { type: Object, default: null },
		baseStationId: { type: [String, Number], default: null },
		loadBaseStationDetails: { type: Function, default: null },
		span: { type: Number, default: 8 },
		offset: { type: Number, default: 4 },
		description: { type: String, default: '' },
	},
	setup(props, { emit }) {
		const { subNetworkOptions } = useSubnetworkOptions();
		const selectedSubNetworks = useSubformFieldProxy(props.formState, 'subNetworks', emit);
		return {
			subNetworkOptions,
			selectedSubNetworks,
		}
	}
}
</script>
